import obelisk from '../../../clients/obelisk';
import configs from '../../../config/app';

const client = obelisk();

// Create a feature flag
export const createFeatureFlag = async (data) => {
  try {
    const response = await client.post('Configuration/AddOrUpdateClientUiSetting', data);
    return response?.data?.data || null;
  } catch (error) {
    console.error('Error creating feature flag:', error);
    throw error;
  }
};

export const getFeatureFlag = async (tokenOverride) => {
  try {
    const response = await client.get(
      'Configuration/GetClientUiSettingByMetaType',
      {
        metaType: 'flag',
      },
      undefined,
      undefined,
      tokenOverride
        ? {
            Authorization: `Bearer ${tokenOverride}`,
            'API-Key': configs.obeliskApiAuthKey,
          }
        : {
            'API-Key': configs.obeliskApiAuthKey,
          }
    );
    return response?.data?.data || null;
  } catch (error) {
    console.error('Error fetching feature flags:', error);
    throw error;
  }
};

export const getSysFlag = async (tokenOverride) => {
  try {
    const response = await client.get(
      'Configuration/GetClientUiSettingByMetaType',
      {
        metaType: 'sys',
      },
      undefined,
      undefined,
      tokenOverride
        ? {
            Authorization: `Bearer ${tokenOverride}`,
            'API-Key': configs.obeliskApiAuthKey,
          }
        : {
            'API-Key': configs.obeliskApiAuthKey,
          }
    );
    return response?.data?.data || null;
  } catch (error) {
    console.error('Error fetching feature flags:', error);
    throw error;
  }
};

export const deleteFeatureFlag = async (id) => {
  try {
    const response = await client.delete(`Configuration/DeleteClientUiSetting?id=${id}`);
    return response?.data?.data || null;
  } catch (error) {
    console.error('Error deleting feature flag:', error);
    throw error;
  }
};
